/* LAYR bundle configurator — pick a colour per collar, then add the bundle to cart. */
(function () {
  var root = document.getElementById('BundleConfigurator');
  if (!root || root.dataset.init) return;
  root.dataset.init = '1';

  var itemsEl = root.querySelector('[data-bcfg-items]');
  var titleEl = root.querySelector('[data-bcfg-title]');
  var priceEl = root.querySelector('[data-bcfg-price]');
  var compareEl = root.querySelector('[data-bcfg-compare]');
  var saveEl = root.querySelector('[data-bcfg-save]');
  var addBtn = root.querySelector('[data-bcfg-add]');
  var noteEl = root.querySelector('[data-bcfg-note]');

  // Metadata of the entry point (bundle card) the shopper opened. Carried into
  // the cart line items so the drawer can show the right name + discount.
  var currentBundle = {};

  // Colour palette from the section settings.
  var COLORS = [];
  try {
    var raw = document.querySelector('[data-bundle-colors]');
    if (raw) COLORS = JSON.parse(raw.textContent);
  } catch (e) { COLORS = []; }

  // Amount (in cents) parsed from a free-text price like "€ 99.95"; null if none.
  // Grouping separators are stripped before the decimal one is read — see the
  // matching note in cart-drawer-layr.js. "₹ 9,995.00" used to parse as 9.99,
  // which dropped the strikethrough in every market priced over a thousand.
  function parseMoney(str) {
    if (str == null) return null;
    var s = String(str).replace(/[ \s']/g, '');
    var m = s.match(/\d[\d.,]*/);
    if (!m) return null;
    var num = m[0];
    var sep = num.lastIndexOf(',') > num.lastIndexOf('.') ? ',' : '.';
    var tail = num.length - num.lastIndexOf(sep) - 1;
    if (num.indexOf(sep) !== -1 && tail >= 1 && tail <= 2) {
      num = num.slice(0, num.lastIndexOf(sep)).replace(/[.,]/g, '') + '.' + num.slice(num.lastIndexOf(sep) + 1);
    } else {
      num = num.replace(/[.,]/g, '');
    }
    var n = parseFloat(num);
    return isNaN(n) ? null : Math.round(n * 100);
  }

  // Strip surrounding brackets so "[SAVE € 20]" reads as "SAVE € 20".
  function saveLabel(str) {
    return String(str == null ? '' : str).replace(/^\s*\[|\]\s*$/g, '').trim();
  }

  // Only reached for the derived "SAVE x" badge, but it printed a euro sign at
  // every market. Follow the cart's presentment currency like the drawer does.
  function money(cents) {
    var code = window.CART_CURRENCY || 'EUR';
    try {
      return new Intl.NumberFormat(window.CART_LOCALE || 'en', { style: 'currency', currency: code }).format(cents / 100);
    } catch (e) {
      return code + ' ' + (cents / 100).toFixed(2);
    }
  }

  function isLight(hex) {
    if (!hex) return false;
    var h = hex.replace('#', '');
    if (h.length !== 6) return false;
    var r = parseInt(h.slice(0, 2), 16), g = parseInt(h.slice(2, 4), 16), b = parseInt(h.slice(4, 6), 16);
    return (r * 299 + g * 587 + b * 114) / 1000 > 235;
  }

  function swatchHTML(c) {
    if (c.striped) return '<span class="bcfg__swatch bcfg__swatch--striped"></span>';
    var light = isLight(c.hex) ? ' bcfg__swatch--light' : '';
    return '<span class="bcfg__swatch' + light + '" style="background:' + (c.hex || '#dedcd9') + '"></span>';
  }

  function render(data) {
    titleEl.textContent = data.title || 'Bundle';
    priceEl.textContent = data.price || '';
    // Compare-at strikethrough — only when it's genuinely higher than the price
    // (i.e. a real discount is associated with this entry point).
    var priceC = parseMoney(data.price);
    var compareC = parseMoney(data.compare);
    var showCompare = compareC != null && (priceC == null || compareC > priceC);
    compareEl.textContent = showCompare ? data.compare : '';
    compareEl.hidden = !showCompare;
    // SAVE badge: use the entry point's own text if set, otherwise derive it
    // from the compare-at discount (so it stays in sync with the cart's savings).
    var saveText = data.save ? saveLabel(data.save)
      : (showCompare ? 'SAVE ' + money(compareC - priceC) : '');
    saveEl.textContent = saveText;
    saveEl.style.display = saveText ? '' : 'none';
    noteEl.hidden = true;

    var size = Math.max(1, parseInt(data.size, 10) || 1);
    var fallbackThumb = root.getAttribute('data-item-thumb') || data.thumb || '';
    var bg = data.bg || '#dedcd9';
    var html = '';
    for (var i = 0; i < size; i++) {
      // default selection cycles through the palette (item 1 -> colour 1, etc.)
      var def = i % COLORS.length;
      var defImg = (COLORS[def] && COLORS[def].image) || fallbackThumb;
      var pills = COLORS.map(function (c, ci) {
        var sel = ci === def ? ' is-selected' : '';
        return '<button type="button" class="bcfg__pill' + sel + '" data-ci="' + ci + '" aria-pressed="' + (ci === def) + '">' +
          swatchHTML(c) + '<span>' + c.label + '</span></button>';
      }).join('');
      html +=
        '<div class="bcfg__item" data-item="' + i + '">' +
          '<div class="bcfg__thumb" style="background:' + bg + '">' + (defImg ? '<img src="' + defImg + '" alt="">' : '') + '</div>' +
          '<div class="bcfg__item-main">' +
            '<p class="bcfg__item-label">Pick item ' + (i + 1) + '</p>' +
            '<div class="bcfg__pills">' + pills + '</div>' +
          '</div>' +
        '</div>';
    }
    itemsEl.innerHTML = html;
  }

  function open(data) { currentBundle = data || {}; render(data); root.classList.add('is-open'); root.setAttribute('aria-hidden', 'false'); document.body.style.overflow = 'hidden'; }
  function close() { root.classList.remove('is-open'); root.setAttribute('aria-hidden', 'true'); document.body.style.overflow = ''; }

  function selectedVariants() {
    var ids = [];
    root.querySelectorAll('.bcfg__item').forEach(function (item) {
      var sel = item.querySelector('.bcfg__pill.is-selected');
      var ci = sel ? parseInt(sel.getAttribute('data-ci'), 10) : 0;
      ids.push((COLORS[ci] || {}).variant || '');
    });
    return ids;
  }

  // Selected colour labels, in "Pick item 1, 2…" order.
  function selectedColorLabels() {
    var labels = [];
    root.querySelectorAll('.bcfg__item').forEach(function (item) {
      var sel = item.querySelector('.bcfg__pill.is-selected');
      var ci = sel ? parseInt(sel.getAttribute('data-ci'), 10) : 0;
      labels.push((COLORS[ci] || {}).label || '');
    });
    return labels;
  }

  function addToCart() {
    var bundleName = currentBundle.title || titleEl.textContent || 'Bundle';
    // Free shipping is signalled by the entry point's description text.
    var freeShip = /free\s*shipping/i.test(currentBundle.subtitle || '');
    var items;

    if (currentBundle.variant) {
      // Dedicated bundle product: one line item at the bundle's own price, with
      // the chosen colours as visible properties (so cart + order show them).
      // No spreading discount — the price is baked into the product.
      var labels = selectedColorLabels();
      var bprops = {};
      labels.forEach(function (label, i) { if (label) bprops['Colour ' + (i + 1)] = label; });
      if (currentBundle.compare) bprops['_bundle_compare'] = currentBundle.compare;
      if (currentBundle.thumb) bprops['_bundle_image'] = currentBundle.thumb;
      if (freeShip) bprops['_bundle_free_ship'] = '1';
      items = [{ id: currentBundle.variant, quantity: 1, properties: bprops }];
    } else {
      // Legacy fallback: add the individual collar variants. Tagged with a
      // shared _bundle_id so the drawer can group several DIFFERENT variants
      // (one per colour) into one row — that's only meaningful once there is
      // more than one of them.
      //
      // A size-1 card ("The Classic Collar" on its own) used to get the same
      // tag, which routes it into the drawer's bundle-branch grouping — a
      // branch that never merges with anything else, by design, since a real
      // bundle's own lines shouldn't silently absorb an unrelated later add.
      // That meant a single collar added here could never combine with the
      // SAME variant added any other way (the in-cart "add one more" upsell,
      // a second visit to this same card) — two identical rows sitting side
      // by side instead of one row reading 2, and never reaching the pack
      // discount either. Leaving off the bundle tags for a size-1 pick lets
      // it fall into the drawer's ordinary product+variant grouping instead,
      // which merges correctly with any other line for that same variant.
      // _bundle_compare/_bundle_image/_bundle_free_ship are read by that
      // branch too, so a promotional price or thumbnail set on this card
      // still comes through — only the id/pos pairing tied to multi-colour
      // grouping is skipped.
      var ids = selectedVariants();
      if (ids.some(function (id) { return !id; })) {
        noteEl.hidden = false;
        noteEl.textContent = 'This bundle isn’t purchasable yet — add the collar product’s colour variant IDs in the theme editor to enable checkout.';
        return;
      }
      var isMultiPick = ids.length > 1;
      var bundleId = 'b' + Date.now();
      items = ids.map(function (id, i) {
        var props = {};
        if (isMultiPick) {
          props['_bundle'] = bundleName;
          props['_bundle_id'] = bundleId;
          props['_bundle_pos'] = String(i);
        }
        if (currentBundle.save) props['_bundle_save'] = currentBundle.save;
        if (currentBundle.compare) props['_bundle_compare'] = currentBundle.compare;
        if (currentBundle.thumb) props['_bundle_image'] = currentBundle.thumb;
        if (freeShip) props['_bundle_free_ship'] = '1';
        return { id: id, quantity: 1, properties: props };
      });
    }
    addBtn.disabled = true;
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: items })
    })
      .then(function (r) { return r.json().then(function (b) { return { ok: r.ok, body: b }; }); })
      .then(function (res) {
        if (!res.ok) {
          noteEl.hidden = false;
          noteEl.textContent = (res.body && res.body.description) || 'Could not add to cart.';
          return;
        }
        document.dispatchEvent(new CustomEvent('cart:refresh'));
        close();
        var trigger = document.querySelector('[data-cart-drawer-open]');
        if (trigger) trigger.click(); // open the cart drawer
      })
      .catch(function () { noteEl.hidden = false; noteEl.textContent = 'Could not add to cart.'; })
      .finally(function () { addBtn.disabled = false; });
  }

  // ---- events ----
  document.addEventListener('click', function (e) {
    var opener = e.target.closest('[data-bundle-open]');
    if (opener) {
      e.preventDefault();
      open({
        title: opener.getAttribute('data-title'),
        subtitle: opener.getAttribute('data-subtitle'),
        price: opener.getAttribute('data-price'),
        compare: opener.getAttribute('data-compare'),
        save: opener.getAttribute('data-save'),
        size: opener.getAttribute('data-size'),
        thumb: opener.getAttribute('data-thumb'),
        bg: opener.getAttribute('data-bg'),
        variant: opener.getAttribute('data-bundle-variant')
      });
      return;
    }
    if (e.target.closest('[data-bcfg-close]')) { close(); return; }
    if (!root.contains(e.target)) return;

    var pill = e.target.closest('.bcfg__pill');
    if (pill) {
      var group = pill.closest('.bcfg__item');
      group.querySelectorAll('.bcfg__pill').forEach(function (p) { p.classList.remove('is-selected'); p.setAttribute('aria-pressed', 'false'); });
      pill.classList.add('is-selected'); pill.setAttribute('aria-pressed', 'true');
      // Update the item thumbnail to the picked colour's collar.
      var ci = parseInt(pill.getAttribute('data-ci'), 10);
      var img = group.querySelector('.bcfg__thumb img');
      var src = (COLORS[ci] && COLORS[ci].image) || root.getAttribute('data-item-thumb');
      if (img && src) img.src = src;
      return;
    }
    if (e.target.closest('[data-bcfg-add]')) { addToCart(); return; }
  });

  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });

  requestAnimationFrame(function () {
    requestAnimationFrame(function () { root.classList.add('bcfg--ready'); });
  });
})();
